import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Footer() {
  return (
    <section className="footer-lp text_white">
      <Container>
        <Row className="align-items-center">
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="mb-4 mb-md-0 text-md-start text-center"
          >
            <StaticImage
              src="../../../images/landing/rv-community/Tek-logo.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={200}
              height={30}
            />
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="text-md-end text-center"
          >
            <h5 style={{ marginBottom: "0px" }}>
              COPYRIGHT 2024 TEKREVOL ALL RIGHTS RESERVED.
            </h5>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Footer;
